module.exports = __webpack_public_path__ + "static/media/bcare.933816bb.jpg";